module.exports = __webpack_public_path__ + "img/toys-and-hobby-icon.76a971c37d5b46baca38f5a0b2ffa234.svg";